<template>
  <div class="position-fixed z-h">
    <van-nav-bar
      class="app-header"
      title=""
      left-arrow
      @click-right="onClickRight">
      <template #left>
        <a href="/"><img src="/static/img/index/logo.png"/></a>
      </template>
      <template #right>
        <svg v-if="!isShowNav" t="1592786823378" class="icon" viewBox="0 0 1024 1024" version="1.1"
             xmlns="http://www.w3.org/2000/svg" p-id="1121" width="24" height="24">
          <path
            d="M832.2 264.6H192.3c-35.2 0-64-28.8-64-64s28.8-64 64-64h639.8c35.2 0 64 28.8 64 64 0.1 35.2-28.7 64-63.9 64zM832.2 577.9H196.1c-35.2 0-64-28.8-64-64s28.8-64 64-64h636.1c35.2 0 64 28.8 64 64s-28.8 64-64 64zM832.2 896.9H192.3c-35.2 0-64-28.8-64-64s28.8-64 64-64h639.8c35.2 0 64 28.8 64 64 0.1 35.2-28.7 64-63.9 64z"
            fill="#888888" p-id="1122"></path>
        </svg>
        <svg v-if="isShowNav" t="1592787047596" class="icon" viewBox="0 0 1024 1024" version="1.1"
             xmlns="http://www.w3.org/2000/svg" p-id="2699" width="24" height="24">
          <path
            d="M519.02036023 459.47959989L221.8941505 162.35411435a37.07885742 37.07885742 0 1 0-52.45354772 52.40502656l297.12476134 297.15010821L169.44060278 809.05863314a37.07885742 37.07885742 0 1 0 52.42964924 52.42892505l297.15010821-297.12476136 297.15010822 297.12476136a37.07885742 37.07885742 0 1 0 52.42892504-52.40430237l-297.12476135-297.1740067 297.12476135-297.12548553a37.07885742 37.07885742 0 1 0-52.42892504-52.42964924L519.04498291 459.47959989z"
            p-id="2700" fill="#888888"></path>
        </svg>

        <!--<div v-if="showAva" @click="toPage" class="overflow-hidden d-flex align-items-center">-->
        <!--<van-image round width="2rem" height="2rem" src="https://img.yzcdn.cn/vant/cat.jpeg"/>-->
        <!--<van-icon name="arrow-down" class="ml-1 font-16 font-weight-bold"/>-->
        <!--</div>-->
      </template>
    </van-nav-bar>

    <div v-if="isShowNav"
         class="app-dropdown-menu mx-0 mb-0 border-0" aria-labelledby="dropdownMenuLink">
      <a class="dropdown-item" href="/">首页</a>
      <div class="d-flex justify-content-center mb-5 overflow-hidden">
        <div v-if="!showAva" @click="goLogin"
             class="btn  btn-outline-secondary mt-3 login-btn mb-5">登录
        </div>
        <a v-if="showAva" href="javascript:;" @click="logout"
           class="btn  btn-outline-secondary mt-3 login-btn mb-5">退出</a>
      </div>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';
  import {Image as VanImage} from 'vant';
  import {Icon} from 'vant';
  import {NavBar} from 'vant';

  Vue.use(VanImage);
  Vue.use(Icon);
  Vue.use(NavBar);
  import Cookies from 'js-cookie'

  export default {
    name: "indexHeaderNav",
    props: [
      'noBtn'
    ],
    data() {
      return {
        isShowNav: false,
        showAva: false,
        domain: ''
      }
    },
    mounted() {
      let names = window.location.hostname.split(".");
      if (names.length > 2) {
        names[0] = "";
      }
      this.domain = names.join(".");

      if (Cookies.get('anqiu_education_token')) {
        this.showAva = true;
      } else {
        this.showAva = false;
        this.$store.commit('MOVE_TOKEN', {name: {key: 'u_info'}, options: {domain: this.domain}});

      }
    },
    methods: {
      onClickRight() {
        let wid = $('.app-header').css('width');
        let $style = $('<style type="text/css"></style>');
        $($('head')[0]).append($style);
        $style.append('.app-dropdown-menu {min-width: ' + wid + ';}');

        this.showAva = Cookies.get('u_info') ? true : false;

        if (this.noBtn) {
          return false;
        }
        this.isShowNav = !this.isShowNav;

      },
      goLogin() {
        if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
          this.$router.push('/login');
          localStorage.setItem('current_url', location.pathname);
        } else {
         window.open('https://www.aqjsjx.com.cn/passport/login')
        }

      },
      logout() {
        this.$store.commit('MOVE_TOKEN', {name: {key: 'anqiu_education_token'}, options: {domain: this.domain}});
        this.$store.commit('MOVE_TOKEN', {name: {key: 'anqiu_education_refresh_token'}, options: {domain: this.domain}});
        this.$store.commit('MOVE_TOKEN', {name: {key: 'u_info'}, options: {domain: this.domain}});
        this.showAva = false;
      }
    }
  }
</script>

<style>
  .z-h {
    z-index: 999;
  }
</style>
